/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import { StyledCancelIcon, StyledCancelIconContainer, StyledErrorMessageMobileView, StyledFileSize, StyledFileSizeContainer, StyledListItem, StyledProgressBarContainer, StyledFileUploadItem, StyledRetryButtonContainer } from './styles';
import { Utilities } from "../../utilities";
import { ProgressBar, ProgressBarHeight } from "../progress-bar";
import { getProgress, getProgressColor, isFileDataEqual } from './services';
import { Magnetic as Mi } from '../../styles';
import { FileUploadListItemThumbnail } from './FileUploadListItemThumbnail';
import { FileUploadListItemFileInfo } from './FileUploadListItemFileInfo';
import { FileUploadListItemFileInfoErrorMessage } from './FileUploadListItemFileInfoErrorMessage';
import { ViewportSize } from "../../common";
import { useViewportSize } from "../../hooks";
import { Button, ButtonStyle } from "../../public_apis";
const FileUploadListItemInternal = ({ file, shouldHaveBorder, shouldHideThumbnail = false, progressBarColor, translateFn = (key) => key, onCancel, onRetry }) => {
    const styledFileSizeContainer = (jsx(StyledFileSizeContainer, null,
        jsx(StyledFileSize, null, Utilities.convertFileSizeToString(file.fileSize))));
    const styledProgressBarContainer = (jsx(StyledProgressBarContainer, null,
        jsx(ProgressBar, { progress: getProgress(file.isDone, file.progress), color: getProgressColor(file.isUploadFailed, progressBarColor), height: ProgressBarHeight.SMALL })));
    const handleOnCancel = () => {
        if (onCancel) {
            onCancel(file.id);
        }
    };
    const handleOnRetry = () => {
        onRetry && onRetry(file);
    };
    const cancelIconCSSClsName = 'mi-icon-rejected-filled-circle';
    const cancelIcon = !file.isDone && file.id ? (jsx(StyledCancelIcon, { onClick: handleOnCancel, className: cancelIconCSSClsName })) : null;
    const viewportSize = useViewportSize();
    const isMobileView = viewportSize.size === ViewportSize.EXTRA_SMALL;
    const mobileView = (jsx(StyledListItem, { css: {
            borderBottom: shouldHaveBorder
                ? `${Mi.baseBorderStyle} ${Mi.baseBorderWidth} ${Mi.colorNeutral20};`
                : undefined
        } },
        jsx(StyledFileUploadItem, null,
            shouldHideThumbnail === false && (jsx(FileUploadListItemThumbnail, { thumbnail: file.thumbnailImage })),
            jsx(FileUploadListItemFileInfo, { file: file, translateFn: translateFn }),
            styledFileSizeContainer,
            styledProgressBarContainer,
            jsx(StyledCancelIconContainer, null, cancelIcon)),
        jsx(StyledErrorMessageMobileView, null,
            jsx(FileUploadListItemFileInfoErrorMessage, { file: file, translateFn: translateFn }))));
    const deskTopView = (jsx(StyledListItem, { css: {
            borderBottom: shouldHaveBorder
                ? `${Mi.baseBorderStyle} ${Mi.baseBorderWidth} ${Mi.colorNeutral20};`
                : undefined
        } },
        shouldHideThumbnail === false && (jsx(FileUploadListItemThumbnail, { thumbnail: file.thumbnailImage })),
        jsx(FileUploadListItemFileInfo, { file: file, translateFn: translateFn }),
        styledFileSizeContainer,
        styledProgressBarContainer,
        jsx(StyledCancelIconContainer, null, cancelIcon),
        jsx(StyledRetryButtonContainer, null, file.shouldShowRetry && (jsx(Button, { style: ButtonStyle.Flat, label: translateFn('Retry'), id: `fileUploadListItem__retry-button_${file.id}`, onClick: handleOnRetry })))));
    return isMobileView ? mobileView : deskTopView;
};
const areFileUploadListItemEqual = (previousProps, nextProps) => {
    return (isFileDataEqual(previousProps.file, nextProps.file) &&
        previousProps.shouldHaveBorder === nextProps.shouldHaveBorder);
};
export const FileUploadListItem = React.memo(FileUploadListItemInternal, areFileUploadListItemEqual);
//# sourceMappingURL=FileUploadListItem.js.map